import { computed } from "vue";
import store from "@/store";

/**
 * The profile's full Wellbeing test (injuryRisk, as the profile pill knows it), which personalised
 * vitamins are mixed from. `known` is false until the kit's tests have loaded.
 */
export function useWellbeingResults() {
    const wellbeing = computed(() => store.getters.kitTests?.injuryRisk ?? null);
    const known = computed(() => !!wellbeing.value);
    // A test being updated keeps its previous results meanwhile
    const hasResults = computed(() => wellbeing.value?.complete === true || wellbeing.value?.status === "updating");
    const purchased = computed(() => wellbeing.value?.purchased === true);
    return { known, hasResults, purchased };
}
